import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=38d8ef99&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=ts"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=38d8ef99&prod&lang=css"
import style1 from "./ProjectDetails.vue?vue&type=style&index=1&id=38d8ef99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d8ef99",
  null
  
)

export default component.exports